<template>
  <m-pageframe title="Search Contact Imports">
    <v-container fluid style="padding: 15px">
      <imports-search-card
        :card_title="'Contact Import History'"
        endpoint_base="/api/v1/imports/contact"
      >
        <template #actions>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <span v-bind="attrs" v-on="on">
                <v-btn color="primary" :disabled="!hasWriteAccess()" v-on:click="onClickImportContact">
                  Import Contacts...
                </v-btn>
              </span>
            </template>
            <span v-if="!hasWriteAccess()">You do not have permission to create imports. Only organization administrators can create or modify imports.</span>
            <span v-else>Import</span>
          </v-tooltip>
        </template>

        <template #default="{ results, loading, footer_props, computed_no_data_text }">
          <imports-data-table
            v-if="results != null"
            :headers="tableHeaders"
            :items="results"
            :items-per-page="50"
            :loading="loading"
            loading_text="Loading contact imports..."
            :no_data_text="computed_no_data_text"
            :footer_props="footer_props"
            import_type="contact"
            upload_route_name="contact-import-upload"
          />
        </template>
      </imports-search-card>
    </v-container>
  </m-pageframe>
</template>

<script>
import ImportsSearchCard from '@/components/common/imports-search-card.vue';
import ImportsDataTable from '@/components/imports/imports-data-table.vue';

export default {
    components: { ImportsSearchCard, ImportsDataTable },
    props: {
        uploadRouteName: {
            type: String,
            default: 'contact-import-upload'
        }
    },

    data() {
        return {
            headers: [
                { text: 'Date', value: 'date', sortable: false },
                { text: 'Time', value: 'time', sortable: false },
                { text: 'Imported By', value: 'imported_by', sortable: false },
                { text: 'File', value: 'file_name', sortable: false },
                { text: 'Mapped File', value: 'enriched_data', sortable: false},
                { text: 'Status', value: 'state', sortable: false },
                { text: 'Contact Records Imported', value: 'records_imported', sortable: false },
                { text: 'Actions', value: 'actions', sortable: false },
            ],
        }
    },

    computed: {
        tableHeaders() {
            if (this.$rc.$state.isAuthActorSystemAdmin()) {
                return this.headers;
            }
            else {
                return this.headers.filter((item) => item.showForStaffOnly !== true);
            }
        }
    },

    methods: {

        onClickImportContact() {
            this.$router.push({
                name: this.uploadRouteName,
                params: { organization_id: this.$route.params.organization_id }
            });
        },

        hasWriteAccess() {
            // Check if current user has write access to contact list imports
            const organization_id = this.$route.params.organization_id;

            if (this.$rc.$state.isAuthActorSystemAdmin()) {
                // RedChirp staff can write in any organization (UI will warn on real accounts)
                return true;
            } else if (this.$rc.$state.isOrganizationAdmin(organization_id)) {
                // Organization admins can write to their organization
                return true;
            }

            // Regular users cannot write
            return false;
        },
    }
};
</script>

<style lang="scss" scoped>
.v-chip {
    font-size: 11px;
}

// Enhanced table styles - replicated from EnhancedDataTable
.enhanced-data-table {
    ::v-deep .v-data-table__wrapper {
        border-radius: 8px;
    }

    ::v-deep tbody tr {
        transition: all 0.2s ease-in-out;

        &:hover {
            background-color: rgba(var(--v-primary-base), 0.04) !important;
        }

        &.table-row--selected {
            background-color: rgba(var(--v-primary-base), 0.08) !important;

            &:hover {
                background-color: rgba(var(--v-primary-base), 0.12) !important;
            }
        }
    }

    ::v-deep th {
        font-weight: 600 !important;
        color: rgba(0, 0, 0, 0.87) !important;
        background-color: #fafafa !important;
    }
}
</style>
